
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class CompanyStatusSummaryModel extends Model<CompanyStatusSummaryModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'hasFuturePlansInProduction', type: 'boolean', languageString: 'companyStatusSummary.property.hasFuturePlansInProduction' },
		{ name: 'hasActiveAllTerminatedPlans', type: 'boolean', languageString: 'companyStatusSummary.property.hasActiveAllTerminatedPlans' },
		{ name: 'hasActiveUnterminatedPlans', type: 'boolean', languageString: 'companyStatusSummary.property.hasActiveUnterminatedPlans' },
		{ name: 'hasPlans', type: 'boolean', languageString: 'companyStatusSummary.property.hasPlans' },
		{ name: 'hasNewUnapprovedOrders', type: 'boolean', languageString: 'companyStatusSummary.property.hasNewUnapprovedOrders' },
		{ name: 'inDebtCollection', type: 'boolean', languageString: 'companyStatusSummary.property.inDebtCollection' },
		{ name: 'hasOverdueLedgers', type: 'boolean', languageString: 'companyStatusSummary.property.hasOverdueLedgers' },
		{ name: 'hasActiveSettlement', type: 'boolean', languageString: 'companyStatusSummary.property.hasActiveSettlement' }
	];
	[key: string]: any;
	
	public hasFuturePlansInProduction: boolean;
	public hasActiveAllTerminatedPlans: boolean;
	public hasActiveUnterminatedPlans: boolean;
	public hasPlans: boolean;
	public hasNewUnapprovedOrders: boolean;
	public inDebtCollection: boolean;
	public hasOverdueLedgers: boolean;
	public hasActiveSettlement: boolean;
    
	constructor(){
		super();
		this.hasFuturePlansInProduction = false;
		this.hasActiveAllTerminatedPlans = false;
		this.hasActiveUnterminatedPlans = false;
		this.hasPlans = false;
		this.hasNewUnapprovedOrders = false;
		this.inDebtCollection = false;
		this.hasOverdueLedgers = false;
		this.hasActiveSettlement = false;
		
	}
	getProperties(){
		return CompanyStatusSummaryModel.classProperties;
	}
}

